// extracted by mini-css-extract-plugin
module.exports = {"main":"main___2lg69","main__flow":"main__flow___p8TUQ"};
    if(module.hot) {
      // 1677682834789
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  